import { useMutation } from 'react-query'

import { licensesService } from '@/modules/licenses/service/licenses-service.ts'

import type { ConnectLicenseContext } from '../types'

export function useConnect() {
  return useMutation((cxt: ConnectLicenseContext) =>
    licensesService.postLicense(cxt.creatorId, cxt.licenseId),
  )
}
